// Pictogram van Gezond op gewicht (0068): klein en los, zodat het menu het kan tonen zonder de
// pagina te laden. Eigen tekening (geen standaardset): een kom met een blaadje en een zachte boog,
// in dezelfde lijnstijl als de sprite (24 × 24, ronde uiteinden).

export function KompasGlyph({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.9"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      <path d="M3.5 12.5h17a8.5 8.5 0 0 1-17 0z" />
      <path d="M9 21h6" />
      <path d="M12.5 9.5c0-3 2-5.5 5.5-6-.3 3.4-2.4 5.6-5.5 6z" />
      <path d="M12.5 9.5c-.4-1.6-1.5-2.8-3.5-3.3" />
    </svg>
  );
}
